import DelayedFallback from "./DelayedFallback";

const BlockLoader = () =>{
    return (
    <DelayedFallback/>
      );
}


export default BlockLoader